<script setup lang="ts">
import { type PropType } from 'vue';
import { inputProps } from 'naive-ui';

const props = defineProps({
  ...inputProps,
  // Chat composers grow with their content; callers can pass false or their
  // own {minRows, maxRows} to change it.
  autosize: {
    type: [Boolean, Object] as PropType<boolean | { minRows?: number; maxRows?: number }>,
    default: () => ({ minRows: 2 }),
  },
});
</script>

<template>
  <n-input v-bind="props" type="textarea">
    <template v-if="$slots.prefix" #prefix>
      <slot name="prefix" />
    </template>
    <template v-if="$slots.suffix" #suffix>
      <slot name="suffix" />
    </template>
  </n-input>
</template>
